export enum ResourceStatus {
  OK = 'OK',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
}
